﻿import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';

const _hcRenders = {
	priceHistoryTooltipETF: ({ x, point }) => (`<div>
            <div>As of ${Highcharts.dateFormat('%b %e, %Y', new Date(x))}</div>
            <div class="highcharts__tooltip--line">
                <div class="highcharts__tooltip--label">Market Price:</div>
                <div>$${Highcharts.numberFormat(point.market_price, 2)}</div>
            </div>
            <div class="highcharts__tooltip--line">
                <div class="highcharts__tooltip--label">Net Asset Value:</div>
                <div>$${Highcharts.numberFormat(point.net_asset_value, 2)}</div>
            </div>
            <div class="highcharts__tooltip--line">
                <div class="highcharts__tooltip--label">Bid/Ask Midpoint:</div>
                <div>$${Highcharts.numberFormat(point.bid_ask_midpoint, 2)}</div>
            </div>
            <div class="highcharts__tooltip--line">
                <div class="highcharts__tooltip--label">Volume:</div>
                <div>${Highcharts.numberFormat(point.volume, -1, null, ',')}</div>
            </div>
            <div class="highcharts__tooltip--line">
                <div class="highcharts__tooltip--label">Net Assets:</div>
                <div>$${Highcharts.numberFormat(point.net_assets, 0, null, ',')}</div>
            </div>
        </div>`
	),
	priceHistoryTooltipCEF: ({ x, point }) => (`<div>
            <div>As of ${Highcharts.dateFormat('%b %e, %Y', new Date(x))}</div>
            <div class="highcharts__tooltip--line">
                <div class="highcharts__tooltip--label">Market Price:</div>
                <div>$${Highcharts.numberFormat(point.market_price, 2)}</div>
            </div>
            <div class="highcharts__tooltip--line">
                <div class="highcharts__tooltip--label">Net Asset Value:</div>
                <div>$${Highcharts.numberFormat(point.net_asset_value, 2)}</div>
            </div>
            <div class="highcharts__tooltip--line">
                <div class="highcharts__tooltip--label">Premium (Discount):</div>
                <div>${Highcharts.numberFormat(point.premium_discount * 100.0, 2, null, ',')}%</div>
            </div>
            <div class="highcharts__tooltip--line">
                <div class="highcharts__tooltip--label">Volume:</div>
                <div>${Highcharts.numberFormat(point.volume, -1, null, ',')}</div>
            </div>
            <div class="highcharts__tooltip--line">
                <div class="highcharts__tooltip--label">Net Assets:</div>
                <div>$${Highcharts.numberFormat(point.net_assets, 0, null, ',')}</div>
            </div>
        </div>`),
	priceHistoryTooltipMF: ({ x, point }) => (`<div>
            <div>As of ${Highcharts.dateFormat('%b %e, %Y', new Date(x))}</div>
            <div class="highcharts__tooltip--line">
                <div class="highcharts__tooltip--label">Net Asset Value:</div>
                <div>$${Highcharts.numberFormat(point.net_asset_value, 2)}</div>
            </div>
            <div class="highcharts__tooltip--line">
                <div class="highcharts__tooltip--label">Net Assets:</div>
                <div>$${Highcharts.numberFormat(point.net_assets, 0, null, ',')}</div>
            </div>
        </div>`),
	priceHistoryTooltipVA: ({ x, point }) => (`<div>
            <div>As of ${Highcharts.dateFormat('%b %e, %Y', new Date(x))}</div>
            <div class="highcharts__tooltip--line">
                <div class="highcharts__tooltip--label">Net Asset Value:</div>
                <div>$${Highcharts.numberFormat(point.net_asset_value, 2)}</div>
            </div>
        </div>`),
	priceHistoryTooltipUIT: ({ x, point }, showParValue) => {
		var parValue = showParValue
			? `
            <div class="highcharts__tooltip--line">
                <div class="highcharts__tooltip--label">Par Value:</div>
                <div>$${Highcharts.numberFormat(point.par_value, 4, null, ',')}</div>
            </div>
			`
			: '';

		return `
		<div>
            <div>As of ${Highcharts.dateFormat('%b %e, %Y', new Date(x))}</div>
            <div class="highcharts__tooltip--line">
                <div class="highcharts__tooltip--label">Net Asset Value:</div>
                <div>$${Highcharts.numberFormat(point.net_asset_value, 4, null, ',')}</div>
            </div>
            <div class="highcharts__tooltip--line">
                <div class="highcharts__tooltip--label">Offer Price:</div>
                <div>${point.offer_price_value > 0 ? '$' + Highcharts.numberFormat(point.offer_price_value, 4, null, ',') : "----"}</div>
            </div>
        </div>
		${parValue}
		`;
	},
	bidAskPremiumTooltip: ({ y, x }) => (`<div>
            <div><strong>${y < 0 ? 'Discount' : 'Premium'}</strong></div>
            <div>
                ${Highcharts.dateFormat('%b %e, %Y', new Date(x))} : ${Highcharts.numberFormat(y, 2)}%
            </div>
        </div>`),
	targetOutcomeChartTooltip: ({ point, series, x, y }, showCap, showBuffer) => {
		var asOfDateTime = point.prc_type == 'Intraday' ? ` at ${Highcharts.dateFormat('%l:%M %p', point.time_stamp)} ET` : '';

		// Only show Remaining Cap information in the chart tool tip if Cap information exists(i.e.this is NOT an Uncapped Buffer)
		var capLine = showCap
			? `
                <div class="highcharts__tooltip--line">
                    <div class="highcharts__tooltip--label">Remaining Cap (Net):</div>
                    <div>${Highcharts.numberFormat(point.rmg_cap, 2)}% (${Highcharts.numberFormat(point.rmg_cap_net, 2)}%)</div>
                </div>
            `
			: '';

		// Only show Remaining Buffer information in the chart tool tip if Buffer information exists(i.e.this is NOT an Enhanced Buffer)
		var buffLine = showBuffer
			? `
                <div class="highcharts__tooltip--line">
                    <div class="highcharts__tooltip--label">Remaining Buffer (Net):</div>
                    <div>${Highcharts.numberFormat(point.rmg_buffer, 2)}% (${Highcharts.numberFormat(point.rmg_buffer_net, 2)}%)</div>
                </div>
            `
			: '';

		return `
		<div>
            <div>As of ${Highcharts.dateFormat('%b %e, %Y', new Date(x))}${asOfDateTime}</div>
            <div class="highcharts__tooltip--line">
                <div class="highcharts__tooltip--label"><strong>${series.name}</strong> Value/Return:</div>
                <div>$${Highcharts.numberFormat(point.fnd_value, 2)}/${Highcharts.numberFormat(y, 2)}%</div>
            </div>
            <div class="highcharts__tooltip--line">
                <div class="highcharts__tooltip--label"><strong>${series.chart.series[1].name}</strong> Value/Return:</div>
                <div>$${Highcharts.numberFormat(point.asst_value, 2)}/${Highcharts.numberFormat(point.asst_ret, 2)}%</div>
            </div>
            <div class="highcharts__tooltip--line">
                <div class="highcharts__tooltip--label">Remaining Outcome Period:</div>
                <div>${point.rmg_outcome} days</div>
            </div>
            ${capLine}
            ${buffLine}
        </div>
		`;
	}
};

Exporting(Highcharts);

window.Highcharts = Highcharts;
window.hcRenders = _hcRenders;